import {ForwardedRef, forwardRef} from "react";
import {components, OptionProps, SelectInstance, SingleValueProps} from "react-select";

import {Select} from "@/components/select/Select.tsx";
import {SelectEnumOption, SelectProps} from "@/components/select/Select.types.ts";
import {IncidentState} from "@/lib/types/statuspages.ts";
import {IncidentStateIcon} from "@/pages/incidents/components/incident-edit/components/updates/IncidentStateSelect/IncidentStateIcon.tsx";
import {incidentStateLabel} from "@/pages/incidents/components/incident-edit/components/updates/IncidentStateSelect/IncidentStateSelect.util.ts";

const IncidentStateSingleValue = ({data, ...props}: SingleValueProps<SelectEnumOption<IncidentState>>) => (
  <components.SingleValue {...props} className="d-flex align-items-center" data={data}>
    {data.value && <IncidentStateIcon type={"checks"} variant={"textAndIcon"} className={"me-2"} state={data.value} />}
  </components.SingleValue>
);

const IncidentStateOption = ({data, ...props}: OptionProps<SelectEnumOption<IncidentState>>) => (
  <components.Option {...props} className="d-flex align-items-center" data={data}>
    <IncidentStateIcon type={"checks"} variant={"textAndIcon"} className={"me-2"} state={data.value} />
  </components.Option>
);

const INCIDENT_STATE_ORDER = [
  IncidentState.INVESTIGATION,
  IncidentState.MONITORING,
  IncidentState.IDENTIFIED,
  IncidentState.MAINTENANCE,
  IncidentState.NOTIFICATION,
  IncidentState.RESOLVED,
];

export const IncidentStateSelect = forwardRef(
  (
    {placeholder = "Select Incident State...", ...props}: SelectProps<SelectEnumOption<IncidentState>>,
    ref: ForwardedRef<SelectInstance<SelectEnumOption<IncidentState>>>
  ) => {
    return (
      <Select
        ref={ref}
        variant="chip"
        isSearchable={false}
        placeholder={placeholder}
        options={INCIDENT_STATE_ORDER.map((incidentState) => ({value: incidentState}))}
        getOptionValue={(incidentState) => incidentState.value}
        getOptionLabel={(incidentState) => incidentStateLabel(incidentState.value)}
        components={{Option: IncidentStateOption, SingleValue: IncidentStateSingleValue}}
        {...props}
      />
    );
  }
);
